import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import PartFinderModal from '../tools/PartFinderModal';
import additionalMessages from '../../messages';
import { ProjectProfiles } from '../project/ProjectProfiles';
import { useSelector } from 'react-redux';
import { RootStateOrAny } from '../../store';

function ToolsMenu() {
  const { formatMessage } = useIntl();
  const permissionWrite = useSelector(
    (state) => state.mainFrame.permissionWrite
  );
  const [showPartFinder, setShowPartFinder] = useState(false);
  const [showProjectProfiles, setShowProjectProfiles] = useState(false);

  return (
    <>
      {showPartFinder && (
        <PartFinderModal onClose={() => setShowPartFinder(false)} />
      )}

      {showProjectProfiles && (
        <ProjectProfilesModal onClose={() => setShowProjectProfiles(false)} />
      )}

      <Dropdown
        basic
        text="Tools"
        floating
        labeled
        className="mr-2"
        icon={{ name: '' }}
      >
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => setShowPartFinder(true)}
            icon="search"
            text={formatMessage(additionalMessages.partSearch)}
            title={formatMessage(additionalMessages.partSearchTooltip)}
          ></Dropdown.Item>
          <Dropdown.Item
            onClick={() => setShowProjectProfiles(true)}
            icon={{ className: 'path-profile-icon' }}
            text={formatMessage(additionalMessages.refreshProfiles)}
            title={formatMessage(additionalMessages.refreshProfilesTooltip)}
            disabled={!permissionWrite}
          ></Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

type ProjectProfilesModalProps = {
  open: boolean;
  onClose: () => void;
};

function ProjectProfilesModal({ onClose }: ProjectProfilesModalProps) {
  const projectId = useSelector(
    (state: RootStateOrAny) => state.mainFrame.projectId
  );
  return <ProjectProfiles projectId={projectId} onClose={onClose} />;
}

export default ToolsMenu;
